// little advertisement for the new feature
// only shows if jam mode is off and not on mobile
// this gets deleted when jam mode turns off in toggleJamMode() function
// just for demo purposes
import React, { useState, useEffect } from "react"
import { css } from "emotion"

export default function DoubleClickToCommentInstructionBanner() {
	let [showBanner, setShowBanner] = useState(true)

	useEffect(() => {
		let timer = setTimeout(() => {
			setShowBanner(false)
		}, 4000)

		return () => {
			clearTimeout(timer)
		}
	})

	if (!showBanner) {
		return null
	}

	return (
		<div
			className={css`
				position: fixed;
				box-sizing: border-box;
				top: 1rem;
				left: 50%;
				transform: translate(-50%, 0%);
				z-index: 1000001;
				max-width: 90%;
				background: #2a3632;
				padding: 0 20px;
				box-shadow: 0 4 10 rgba(0, 0, 0, 0.1);
				border-radius: 10px;
			`}
		>
			<p
				className={css`
					font-size: 14px;
					color: #f8f9fb !important;
					font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
						"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
						"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
						"Noto Color Emoji";
					font-weight: 400;
					margin-top: 1rem;
					margin-bottom: 1rem;
				`}
			>
				{"Hey! You're in 🍓Jam mode, double click to leave a comment."}
			</p>
		</div>
	)
}
